import { empty as empty$1, of, isNonEmpty as isNonEmpty$1, headNonEmpty, tailNonEmpty, prepend, isEmpty, reverse, head } from '../../Chunk/dist/effect-Chunk.esm.js';
import { pipe, dual } from '../../Function/dist/effect-Function.esm.js';
import { getOrElse } from '../../Option/dist/effect-Option.esm.js';
import { make as make$1, intersect as intersect$1, isEmpty as isEmpty$1, lessThan as lessThan$1, empty as empty$2 } from '../../ScheduleInterval/dist/effect-ScheduleInterval.esm.js';

/** @internal */
const IntervalsSymbolKey = "effect/ScheduleIntervals";

/** @internal */
const IntervalsTypeId = /*#__PURE__*/Symbol.for(IntervalsSymbolKey);

/** @internal */
const make = intervals => {
  return {
    [IntervalsTypeId]: IntervalsTypeId,
    intervals
  };
};
/** @internal */
const empty = /*#__PURE__*/make( /*#__PURE__*/empty$1());

/** @internal */
const fromIterable = intervals => Array.from(intervals).reduce((intervals, interval) => pipe(intervals, union(make(of(interval)))), empty);

/** @internal */
const union = /*#__PURE__*/dual(2, (self, that) => {
  if (!isNonEmpty$1(that.intervals)) {
    return self;
  }
  if (!isNonEmpty$1(self.intervals)) {
    return that;
  }
  if (headNonEmpty(self.intervals).startMillis < headNonEmpty(that.intervals).startMillis) {
    return unionLoop(tailNonEmpty(self.intervals), that.intervals, headNonEmpty(self.intervals), empty$1());
  }
  return unionLoop(self.intervals, tailNonEmpty(that.intervals), headNonEmpty(that.intervals), empty$1());
});

/** @internal */
const unionLoop = (_self, _that, _interval, _acc) => {
  let self = _self;
  let that = _that;
  let interval = _interval;
  let acc = _acc;
  while (isNonEmpty$1(self) || isNonEmpty$1(that)) {
    if (!isNonEmpty$1(self) && isNonEmpty$1(that)) {
      if (interval.endMillis < headNonEmpty(that).startMillis) {
        acc = pipe(acc, prepend(interval));
        interval = headNonEmpty(that);
        that = tailNonEmpty(that);
        self = empty$1();
      } else {
        interval = make$1(interval.startMillis, headNonEmpty(that).endMillis);
        that = tailNonEmpty(that);
        self = empty$1();
      }
    } else if (isNonEmpty$1(self) && isEmpty(that)) {
      if (interval.endMillis < headNonEmpty(self).startMillis) {
        acc = pipe(acc, prepend(interval));
        interval = headNonEmpty(self);
        that = empty$1();
        self = tailNonEmpty(self);
      } else {
        interval = make$1(interval.startMillis, headNonEmpty(self).endMillis);
        that = empty$1();
        self = tailNonEmpty(self);
      }
    } else if (isNonEmpty$1(self) && isNonEmpty$1(that)) {
      if (headNonEmpty(self).startMillis < headNonEmpty(that).startMillis) {
        if (interval.endMillis < headNonEmpty(self).startMillis) {
          acc = pipe(acc, prepend(interval));
          interval = headNonEmpty(self);
          self = tailNonEmpty(self);
        } else {
          interval = make$1(interval.startMillis, headNonEmpty(self).endMillis);
          self = tailNonEmpty(self);
        }
      } else if (interval.endMillis < headNonEmpty(that).startMillis) {
        acc = pipe(acc, prepend(interval));
        interval = headNonEmpty(that);
        that = tailNonEmpty(that);
      } else {
        interval = make$1(interval.startMillis, headNonEmpty(that).endMillis);
        that = tailNonEmpty(that);
      }
    } else {
      throw new Error("BUG: Intervals.unionLoop - please report an issue at https://github.com/Effect-TS/io/issues");
    }
  }
  return make(pipe(acc, prepend(interval), reverse));
};

/** @internal */
const intersect = /*#__PURE__*/dual(2, (self, that) => intersectLoop(self.intervals, that.intervals, empty$1()));

/** @internal */
const intersectLoop = (_left, _right, _acc) => {
  let left = _left;
  let right = _right;
  let acc = _acc;
  while (isNonEmpty$1(left) && isNonEmpty$1(right)) {
    const interval = pipe(headNonEmpty(left), intersect$1(headNonEmpty(right)));
    const intervals = isEmpty$1(interval) ? acc : pipe(acc, prepend(interval));
    if (pipe(headNonEmpty(left), lessThan$1(headNonEmpty(right)))) {
      left = tailNonEmpty(left);
    } else {
      right = tailNonEmpty(right);
    }
    acc = intervals;
  }
  return make(reverse(acc));
};

/** @internal */
const start = self => {
  return pipe(self.intervals, head, getOrElse(() => empty$2)).startMillis;
};

/** @internal */
const end = self => {
  return pipe(self.intervals, head, getOrElse(() => empty$2)).endMillis;
};

/** @internal */
const lessThan = /*#__PURE__*/dual(2, (self, that) => start(self) < start(that));

/** @internal */
const isNonEmpty = self => {
  return isNonEmpty$1(self.intervals);
};

/** @internal */
const max = /*#__PURE__*/dual(2, (self, that) => lessThan(self, that) ? that : self);

export { IntervalsTypeId, empty, end, fromIterable, intersect, isNonEmpty, lessThan, make, max, start, union };
